import React, { useState, useEffect, useContext } from "react";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInstance";
import Pricing from "../components/Pricing";
import AuthContext from "../AuthContext";
import { FaSpinner, FaSmileBeam, FaSadCry  } from "react-icons/fa";

Modal.setAppElement("#root");

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    businessName: "",
    password: "",
    phone: "",
    howDidYouHearAboutUs: "",
  });


  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("success");
  const [isFormValid, setIsFormValid] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [registering, setRegistering] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate(); 
  
    useEffect(() => {
      // Heartbeat check to backend
      const checkHeartbeat = async () => {
        try {
          const response = await axiosInstance.get("/api/heartbeat/heartbeat");
          console.log("Heartbeat response:", response.data);
        } catch (error) {
          console.error("Heartbeat check failed:", error);
        }
      };
  
      checkHeartbeat();
    }, []);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const validatePhone = (phone) => /^[0-9]+$/.test(phone);

  useEffect(() => {
    const { name, email, password, phone } = formData;
    const isFormFilled = name && email && password && phone ;
    const isValidPhone = validatePhone(phone);
    setIsPhoneValid(isValidPhone);
    setIsFormValid(isFormFilled && isValidPhone);
  }, [formData]);
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setRegistering(true);
    try { 

      const response = await axiosInstance.post("/api/register", formData); 
      if (response.status === 201) {
        setMessage("Registration successful! Please get membership to continue.");
        setMessageType("success");
        setShowMessageModal(true);
      } 
    } catch (error) {
      setMessage("Something went wrong. Please try again.");
      setMessageType("error");
      setShowMessageModal(true);
    }
    setRegistering(false);
  };

  const closeModal = () => {
    setShowMessageModal(false);
    if (messageType === "success") navigate("/login");
  };

  return (
    <div className="max-w-lg mx-auto p-8 bg-white rounded-xl shadow-lg mt-6">
      <h1 className="text-3xl font-extrabold mb-6 text-gray-800 text-center">
        Create Your Account
      </h1>
      <form onSubmit={handleSubmit} className="space-y-5">
        {/* Name */}
        <div>
          <label className="block text-sm font-semibold mb-1" htmlFor="name">
          <span className="text-lg"> Name</span>
          </label>
          <input
            type="text"
            name="name"
            placeholder="Your full name"
            value={formData.name}
            onChange={handleChange}
            className="w-full bg-white text-black border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>

        {/* Business Name (optional) */}
        <div>
          <label
            className="block text-sm font-semibold mb-1"
            htmlFor="businessName"
          >
           <span className="text-lg"> Business Name(Optional)</span> 
          </label>
          <input
            type="text"
            name="businessName"
            placeholder="Your business name"
            value={formData.businessName}
            onChange={handleChange}
            className="w-full bg-white text-black border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-semibold mb-1" htmlFor="email">
          <span className="text-lg"> Email*</span>
          </label>
          <input
            type="email"
            name="email"
            placeholder="you@example.com"
            value={formData.email}
            onChange={handleChange}
            className="w-full bg-white text-black border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>

        {/* Password */}
        <div>
          <label
            className="block text-sm font-semibold mb-1"
            htmlFor="password"
          >
            <span className="text-lg">Password</span>
          </label>
          <input
            type="password"
            name="password"
            placeholder="Choose a strong password"
            value={formData.password}
            onChange={handleChange}
            className="w-full bg-white text-black border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
             required
          />
        </div>

        {/* Phone */}
        <div>
          <label className="block text-sm font-semibold mb-1" htmlFor="phone">
          <span className="text-lg"> Phone</span>
          </label>
          <input
            type="tel"
            name="phone"
            placeholder="Numeric only"
            value={formData.phone}
            onChange={handleChange}
            className={`w-full border bg-white rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 ${
              !isPhoneValid ? "border-red-500" : "border-gray-300"
            }`}
            required
          />
          {!isPhoneValid && (
            <p className="text-red-500 text-xs mt-1">
              Phone number must be numeric.
            </p>
          )}
        </div>

        {/* Referral */}
        <div>
          <label
            className="block text-sm font-semibold mb-1"
            htmlFor="referral"
          >
           <span className="text-lg">  How did you hear about us ?</span>
          </label>
          <select
            name="howDidYouHearAboutUs"
            value={formData.howDidYouHearAboutUs}
            onChange={handleChange}
            className="w-full border bg-white border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
            required
          >
            <option value="">Select an option</option>
            <option value="SawItSomewhere">Saw it somewhere</option>
            <option value="social">Social Media</option>
            <option value="friend">Friend or Colleague</option>
            <option value="ad">Online Advertisement</option>
            <option value="search">Search Engine</option>
          </select>
        </div>

        {/* Submit */}
        <div>
          <button
            type="submit" 
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-lg flex justify-center"
          >
            {registering ? (
              <FaSpinner className="animate-spin mt-1" />
            ) : (
              "Register"
            )}
          </button>
        </div>
      </form>

      {/* Modal */}
      <Modal
        isOpen={showMessageModal}
        onRequestClose={closeModal}
        contentLabel="Registration Status"
        className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75"
      >
        <div className="bg-white rounded-lg p-8 max-w-md w-full">
          <h2
            className={`text-2xl font-bold mb-4 ${
              messageType === "success" ? "text-green-600" : "text-red-600"
            }`}
          >
            {messageType === "success" ? <FaSmileBeam /> : <FaSadCry />}
          </h2>
          <p>{message}</p>
          {messageType === "success" && (
            <Pricing email={formData.email} duringRegistration={true} />
          )}
          <button
            onClick={closeModal}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
          >
            Close
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Register;